import { OrderPatient } from './orderPatient';
import { Address } from '@classes/address';
import { BaseClass } from '../base-class';
import { OrderScan } from './orderScan';
import { Tariff } from '@classes/tariff';

export class OrderStep extends BaseClass {
  address: Address
  otherAddress: string;
  service: string;
  ordererComment: string;
  isPickup: boolean;
  isDelivery: boolean;

  tariffs?: Tariff[];

  arrivedOn?: Date;
  completedOn?: Date;
  driverComment?: string;
  hasSignature?: boolean;
  signatory?: string;
  scans?: OrderScan[];
  scansGroupedByContainer?: {};
  tagScanned?: string;
  transportVoucher?: string;
  editVoucher?: boolean;
  editArrivedOn?: boolean;
  editCompletedOn?: boolean;
  editMode?: boolean;
  patients?: OrderPatient[];
  hasPhoto?: boolean;
  waitingTime?: number;

  constructor()
  constructor(
    address: Address, otherAddress: string, service: string, ordererComment: string, isPickup: boolean, isDelivery: boolean, patients?: OrderPatient[], tariffs?: Tariff[])
  constructor(
    address?: Address, otherAddress?: string, service?: string, ordererComment?: string, isPickup?: boolean, isDelivery?: boolean, patients?: OrderPatient[], tariffs?: Tariff[]) {
    super();

    this.address = address;
    this.otherAddress = otherAddress;
    this.service = service;
    this.ordererComment = ordererComment;
    this.isPickup = isPickup;
    this.isDelivery = isDelivery;
    this.patients = patients;
    this.tariffs = tariffs;
  }

  static fromObject(object: OrderStep): OrderStep {
    return Object.assign(new OrderStep(), {
      ...object,
      address: object.address ? Address.fromObject(object.address) : object.otherAddress
    });
  }

  get display(): string {
    return this.address.name || this.otherAddress;
  }
}
